import { SgwtMiniFooter } from '@sgwt/sgwt-widgets-react';
import type { JSX } from 'react';

export function MiniFooter(): JSX.Element {
  return (
    <SgwtMiniFooter
      type="micro"
      design="light"
      mode="b2b2c"
      cookiesConsent
      contactUsByHelpCenter="sgwt-help-center"
      legalNotices={
        {
          "en": [
            {
              label: "SG Markets Luxembourg General Terms",
              value: "/en/termsOfService",
              openInSamePage: false
            },
            {
              label: "Specific terms of services for SG Luxembourg",
              value: "/en/termsOfServiceLUX",
              openInSamePage: false
            },
            {
              label: "Security guidelines",
              value: 'https://wholesale.banking.societegenerale.com/en/information-security/',
              openInSamePage: false,
            },
            {
              label: "Privacy policy and cookies charter",
              value: '/en/cookies',
              openInSamePage: false,
            }
          ],
          "fr": [
            {
              label: "CGU SG Market Luxembourg",
              value: "/fr/termsOfService",
              openInSamePage: false
            },
            {
              label: "Conditions particulières SG Luxembourg",
              value: "/fr/termsOfServiceLUX",
              openInSamePage: false
            },
            {
              label: "Recommandations de sécurité",
              value: 'https://wholesale.banking.societegenerale.com/fr/securite-linformation/',
              openInSamePage: false,
            },
            {
              label: "Politique données personnelles et charte cookies",
              value: '/fr/cookies',
              openInSamePage: false,
            }
          ]
        }
      }
    />
  );
}
